
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class QuotationItemsGrid extends _Ext.GridBase<POSQuotationItemsRow, any> {
        protected getColumnsKey() { return 'Retail.QuotationItems'; }
        protected getDialogType() { return POSQuotationItemsDialog; }
        protected getIdProperty() { return POSQuotationItemsRow.idProperty; }
        protected getInsertPermission() { return POSQuotationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSQuotationItemsRow.localTextPrefix; }
        protected getService() { return POSQuotationItemsService.baseUrl; }
       // protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }

        constructor(container: JQuery, options) {
            super(container, options);

            (this.view.params as TransactionRequest).POSCustomerId = options.GridFilters.CustomerId;
        }
        
    }
} 